import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { Trip } from "./types"
import { fromApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

type Input = Readonly<{ policyId: string; tripId: string }>
type Output = Trip & {
  geojsonUrl?: string
  geoJsonStringContent?: string
}

const findTrip = createRequest<Input, Output>(async (input: Input, getToken): Promise<Output> => {
  const useNewPipeline = isNewPipelinePolicy(input.policyId)
  const result = await platform(getToken).trips.findTrip({
    ...input,
    ...(useNewPipeline ? { dbName: `athena` } : {}),
  })
  return fromApi(result)
})

export const useFindTrip = createRequestHook<Input, Output>(findTrip)
